import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './Voyage.css';

// Triés du plus proche au plus éloigné du domaine.
const HOTELS = [
  { nom: 'Crêt Bérard', url: 'https://www.hotelsone.com/chexbres-hotels-ch/cret-berard.fr.html', prix: '$$', trajet: '7 min' },
  { nom: 'Hôtel Abaca', url: 'https://www.abaca.ch/', prix: '$', trajet: '11 min' },
  { nom: 'Hôtel de la Place', url: 'https://www.hotel-de-la-place.ch/', prix: '$$', trajet: '11 min' },
  { nom: 'Châtonneyre Hôtel & Restaurant', url: 'https://www.chatonneyre.ch/#hotel', prix: '$$', trajet: '12 min' },
];

function PlanParking({ onClose }) {
  useEffect(() => {
    const onKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  // Rendue dans <body> pour passer au-dessus de la navbar.
  return createPortal(
    <div className="voyage-modal-overlay" onClick={onClose}>
      <div
        className="voyage-modal card"
        role="dialog"
        aria-modal="true"
        aria-label="Plan du parking"
        onClick={(event) => event.stopPropagation()}
      >
        <button type="button" className="voyage-modal-close" aria-label="Fermer" onClick={onClose}>
          ×
        </button>
        <h2>🅿️ Parking</h2>
        <p>Les zones de parking sont entourées en orange.</p>
        <img
          src="/images/parking.jpg"
          alt="Vue aérienne du Domaine de la Buritaz avec les zones de parking entourées en orange"
        />
      </div>
    </div>,
    document.body
  );
}

function Voyage() {
  const [planOuvert, setPlanOuvert] = useState(false);

  return (
    <div className="section container">
      <h1 className="section-title">Voyage &amp; logistique</h1>
      <p className="section-subtitle">
        Comment rejoindre le Domaine de la Buritaz et où loger sur place.
      </p>

      <div className="voyage-grid">

        <div className="card">
          <h2>🚆 En train</h2>
          <p>
            Gares les plus proches&nbsp;:
            Puidoux-Chexbres et Vevey.
          </p>
          <p>
            Depuis la gare, compte quelques minutes en voiture/taxi jusqu'au domaine.
          </p>
        </div>

        <div className="card">
          <h2>🚗 En voiture</h2>
          <p>
            Le Domaine de la Buritaz se trouve à Puidoux, dans le canton de Vaud, à proximité de
            Vevey et Lausanne. Un parking sera à disposition sur place pour les invités.
          </p>
          <button type="button" className="btn btn-secondary voyage-btn" onClick={() => setPlanOuvert(true)}>
            Voir le parking
          </button>
        </div>

        <div className="card">
          <h2>🏨 Hébergement</h2>
          <p>Quelques hôtels à proximité du domaine (temps de trajet en voiture)&nbsp;:</p>
          <ul className="voyage-hotels">
            {HOTELS.map((hotel) => (
              <li key={hotel.nom}>
                <a href={hotel.url} target="_blank" rel="noopener noreferrer">
                  {hotel.nom}
                </a>
                <span className="voyage-hotel-infos">
                  <span className="voyage-hotel-prix" aria-label={`Prix : ${hotel.prix.length} sur 3`}>
                    {hotel.prix}
                  </span>
                  {hotel.trajet}
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div className="card">
          <h2>🔴 Service Nez Rouge</h2>
          <p>
            Pour que la fête se termine en toute sécurité, un service «&nbsp;Nez Rouge&nbsp;» sera à la
            disposition des invités pour les ramener à leur hôtel ou à la gare. Profite de la
            soirée, on s'occupe du retour&nbsp;!
          </p>
          <p>
            Ce service est mis gratuitement à ta disposition&nbsp;; tu peux toutefois prévoir un petit quelque chose pour le personnel du domaine qui te reconduira.
          </p>
        </div>
      </div>

      {planOuvert && <PlanParking onClose={() => setPlanOuvert(false)} />}
    </div>
  );
}

export default Voyage;
